module.exports = __webpack_public_path__ + "media/icons/page-501b22f4.png";